/**
 * @generated SignedSource<<0dac80e18a21c347e23cb39db4cb64f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type keycloakQuery$variables = Record<PropertyKey, never>;
export type keycloakQuery$data = {
  readonly organization: {
    readonly sso: {
      readonly clientId: string;
      readonly realm: string;
      readonly url: string;
    };
  } | null | undefined;
};
export type keycloakQuery = {
  response: keycloakQuery$data;
  variables: keycloakQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganizationSso",
        "kind": "LinkedField",
        "name": "sso",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "realm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "keycloakQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "keycloakQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3847f7e470841a31af4e99574706e4a8",
    "id": null,
    "metadata": {},
    "name": "keycloakQuery",
    "operationKind": "query",
    "text": "query keycloakQuery {\n  organization {\n    sso {\n      clientId\n      realm\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a056a25060c5b483ce7eb91316d7786";

export default node;
